import { ModelReviewPage } from '@/features/model-review/ModelReviewPage';

export default ModelReviewPage;
